<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">娃娃机</div>
          <div class="contentBottom">
            <div>不占地、能吸粉的商用大屏娃娃机</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="topText">
      结合年轻人的喜爱的娃娃机IP，通过实时视频流技术可实现远
      程抓娃娃。在实体店有限的购物空间里增加了与顾客的互动黏性，
      品牌可以通过娃娃机实现会员转化、权益分发等多种运营活动。
    </div>

    <!-- start -->
    <div class="contentFlex">
      <div class="contentBox">
        <img v-lazy="wawa1" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa2" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa3" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa4" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">使用行业</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- iconFlex start -->
    <div class="iconParent">
      <div class="iconFlex">
        <div class="iconBox">
          <img v-lazy="wawaIcon1" alt>
          <div class="iconText">零售</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon2" alt>
          <div class="iconText">服装</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon3" alt>
          <div class="iconText">餐饮</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon4" alt>
          <div class="iconText">酒店</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon5" alt>
          <div class="iconText">院线</div>
        </div>
      </div>
    </div>
    <!-- iconFlex end -->
    <!-- 产品特色 start -->
    <!-- start -->
    <div class="titleBox" style="margin-top:140px">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg1" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">一人抓取、众人曙目</div>
        <div class="teSeText">用户实时抓取，吸引路人围观。为实体商家带来流量。</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">快捷部署、省时省地</div>
        <div class="teSeText">无需购买一台真实的娃娃机，只需一台屏幕，轻松变身娃娃机。</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img v-lazy="teSeImg2" class="teSeImg" alt>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg3" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">总部管理、统一核销</div>
        <div class="teSeText">品牌总部集中管控，奖品、玩法、数据回流、轻松搞定。</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">灵活扩展、一屏多用</div>
        <div class="teSeText">屏幕可高度自定义，可以海报，视频及其他引流小游戏插播。</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img v-lazy="teSeImg4" class="teSeImg" alt>
      </div>
    </div>
    <!-- 管理平台 start -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">技术优势</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="adminFlex">
      <div class="adminBox">
        <img v-lazy="adminImg1" class="adminBoxImg" alt>
        <div class="textBox">
          <div class="adminTitle">低延迟直播</div>
          <div class="adminText">
            直播延迟不超过1s
            <br>互动延迟不高于150s
          </div>
        </div>
      </div>
      <div class="adminBox">
        <img v-lazy="adminImg2" class="adminBoxImg" alt>
        <div class="textBox">
          <div class="adminTitle">实施远程控制</div>
          <div class="adminText">
            通过手机远程控制
            <br>实体娃娃机
          </div>
        </div>
      </div>
      <div class="adminBox">
        <img v-lazy="adminImg3" class="adminBoxImg" alt>

        <div class="textBox">
          <div class="adminTitle">数据回流</div>
          <div class="adminText">
            交互数据统计回流
            <br>提供营销指导
          </div>
        </div>
      </div>
    </div>
    <!-- 管理平台 end -->
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/UFOCatcherTop.png";
import wawa1 from "@/assets/images/wawa1.png";
import wawa2 from "@/assets/images/wawa2.png";
import wawa3 from "@/assets/images/wawa3.png";
import wawa4 from "@/assets/images/wawa4.png";

import wawaIcon1 from "@/assets/images/wawaIcon1.png";
import wawaIcon2 from "@/assets/images/wawaIcon2.png";
import wawaIcon3 from "@/assets/images/wawaIcon3.png";
import wawaIcon4 from "@/assets/images/wawaIcon4.png";
import wawaIcon5 from "@/assets/images/wawaIcon5.png";

import teSeImg1 from "@/assets/images/teSeImg1.png";
import teSeImg2 from "@/assets/images/teSeImg2.png";
import teSeImg3 from "@/assets/images/teSeImg3.png";
import teSeImg4 from "@/assets/images/teSeImg4.png";

import adminImg1 from "@/assets/images/wawaBottom1.png";
import adminImg2 from "@/assets/images/wawaBottom2.png";
import adminImg3 from "@/assets/images/wawaBottom3.png";

import Bread from "@/components/bread.vue";
export default {
  name: "UFOCatcher",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["产品", "娃娃机"],
      bgImg: bgImg,
      wawa1: wawa1,
      wawa2: wawa2,
      wawa3: wawa3,
      wawa4: wawa4,
      wawaIcon1: wawaIcon1,
      wawaIcon2: wawaIcon2,
      wawaIcon3: wawaIcon3,
      wawaIcon4: wawaIcon4,
      wawaIcon5: wawaIcon5,
      teSeImg1: teSeImg1,
      teSeImg2: teSeImg2,
      teSeImg3: teSeImg3,
      teSeImg4: teSeImg4,
      adminImg1: adminImg1,
      adminImg2: adminImg2,
      adminImg3: adminImg3
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 60%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 74px;
  margin-bottom: 80px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 179px;
}

/* end */
.contentFlex {
  width: 70%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}
.contentBox {
  width: 25%;
  text-align:center;
}
.contentBox img {
  width: 90%;
  max-width: 255px;
  margin: auto;
}
.iconParent {
  background: rgba(238, 238, 238, 1);
  margin-top: 56px;
}
.iconFlex {
  display: flex;
  width: 70%;
  margin: auto;
  padding: 84px 0 60px;
}
.iconBox {
  width: 20%;
  text-align: center;
}
.iconBox img {
  width: 80%;
  max-width: 96px;
}
.iconText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  margin-top: 10px;
}
.teSeParent::after {
  content: "";
  display: block;
  clear: both;
}
.teSeParent {
  width: 70%;
  margin: auto;
  margin-top: 75px;
}
.teSeLeft {
  width: 50%;
  float: left;
}
.teSeRight {
  width: 44%;
  float: right;
}
.teSeImg {
  width: 100%;
  /* max-width: 769px; */
}
.teSeTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin-top: 20%;
}
.teSeText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 10%;
  width: 77%;
}
.teSeLeftTwo {
  width: 36%;
  padding-left: 12.5%;
}
.teSeRightTwo {
  width: 50%;
  text-align:center;
}
.adminFlex {
  width: 70%;
  min-width: 810px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  margin-top: 85px;
}

.adminBox {
  text-align: center;
  position: relative;
  width: 32%;
}
.adminBoxImg {
  width: 100%;
  max-width: 365px;
}

.textBox {
  position: absolute;
  left: calc(50% - 160px);
  bottom: 20px;
}

.adminTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 10px;
}

.adminText {
  width: 320px;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: 400;
  color: rgba(106, 106, 106, 1);
}
</style>



// WEBPACK FOOTER //
// src/view/UFOCatcher.vue